import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'popup-btn-footer',
  templateUrl: './popup-btn-footer.component.html',
  styleUrls: ['./popup-btn-footer.component.scss']
})
export class PopupBtnFooterComponent implements OnInit {
  @Input() isDisableUpdate: boolean;
  @Input() isUpdateAndAdd: boolean;
  @Input() isUpdateAndEdit: boolean;
  @Input() isUpdateAndClose: boolean;
  // tslint:disable-next-line: no-output-native
  @Output() close = new EventEmitter();
  @Output() updateAndAdd = new EventEmitter();
  @Output() updateAndClose = new EventEmitter();
  @Output() updateAndEdit = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }
  updateAndAddPopup(event: any){
    this.updateAndAdd.emit(event);
  }
  closePopup(event){
    this.close.emit(event);
  }
  updateAndClosePopup(event){
    this.updateAndClose.emit(event);
  }
  updateAndEditPopup(event){
    this.updateAndEdit.emit(event);
  }
}
